module.exports = __webpack_public_path__ + "static/media/ranking de grupos aseguradores.35228c43.svg";